// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"c25a8c16","358":"3a22efcb","659":"85f65833","749":"2751dee1"}[chunkId] + ".chunk.css";
};